var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1747 7.97839V6.11827C16.1747 5.21239 16.1747 4.75945 15.9984 4.41344C15.8433 4.10909 15.5958 3.86165 15.2915 3.70657C14.9455 3.53028 14.4925 3.53028 13.5867 3.53027L4.20518 3.53027C3.2993 3.53027 2.84636 3.53027 2.50036 3.70657C2.196 3.86165 1.94856 4.10909 1.79348 4.41344C1.61719 4.75944 1.61719 5.21239 1.61719 6.11827L1.61719 13.8823C1.61719 14.7881 1.61719 15.2411 1.79348 15.5871C1.94856 15.8914 2.196 16.1389 2.50036 16.294C2.84636 16.4703 3.2993 16.4703 4.20518 16.4703L13.5867 16.4703C14.4926 16.4703 14.9455 16.4703 15.2915 16.294C15.5958 16.1389 15.8433 15.8914 15.9984 15.5871C16.1747 15.2411 16.1747 14.7881 16.1747 13.8823V12.0221",
    stroke: "#9A9FA3",
    strokeWidth: 0.970498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7702 12.0218C16.146 12.0218 16.3339 12.0218 16.4902 11.9907C17.1318 11.8631 17.6334 11.3615 17.761 10.7198C17.7921 10.5636 17.7921 10.3757 17.7921 9.9999C17.7921 9.62411 17.7921 9.43622 17.761 9.27997C17.6334 8.63832 17.1318 8.13674 16.4902 8.00911C16.3339 7.97803 16.146 7.97803 15.7702 7.97803L14.1527 7.97803C13.7769 7.97803 13.589 7.97803 13.4328 8.00911C12.7912 8.13674 12.2896 8.63832 12.1619 9.27997C12.1309 9.43622 12.1309 9.62411 12.1309 9.9999C12.1309 10.3757 12.1309 10.5636 12.1619 10.7198C12.2896 11.3615 12.7912 11.8631 13.4328 11.9907C13.589 12.0218 13.7769 12.0218 14.1527 12.0218H15.7702Z",
    stroke: "#9A9FA3",
    strokeWidth: 0.970498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0b0545a61601a3da28a11257865cd0a3.svg";
export { ForwardRef as ReactComponent };